<script lang="ts">
    import AppLayout from '@/layouts/AppLayout.svelte';
    import GuidesLayout from '@/layouts/guides/Layout.svelte';
    import { type BreadcrumbItem } from '@/types';
    import { Link } from '@inertiajs/svelte';
    import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
    import { Kanban, BookOpen, Hammer, Calendar, Users, Smartphone, ArrowRight } from 'lucide-svelte';

    interface Guide {
        slug: string;
        title: string;
        description: string;
        icon: string;
    }

    interface Props {
        guides: Guide[];
    }

    let { guides }: Props = $props();

    const breadcrumbItems: BreadcrumbItem[] = [
        {
            title: 'Guides',
            href: '/guides',
        },
    ];

    const getIcon = (icon: string) => {
        switch (icon) {
            case 'kanban':
                return Kanban;
            case 'hammer':
                return Hammer;
            case 'calendar':
                return Calendar;
            case 'users':
                return Users;
            case 'smartphone':
                return Smartphone;
            default:
                return BookOpen;
        }
    };
</script>

<svelte:head>
    <title>Guides</title>
</svelte:head>

<AppLayout breadcrumbs={breadcrumbItems}>
    <GuidesLayout {guides}>
        <div class="grid gap-4 md:grid-cols-2 lg:grid-cols-3">
            {#each guides as guide (guide.slug)}
                {@const Icon = getIcon(guide.icon)}
                <Link href={route('guides.show', { slug: guide.slug })} class="block">
                    <Card class="h-full transition-colors hover:bg-muted/50">
                        <CardHeader>
                            <div class="flex items-center gap-3">
                                <div class="rounded-lg bg-primary/10 p-2">
                                    <Icon class="h-5 w-5 text-primary" />
                                </div>
                                <CardTitle class="text-lg">{guide.title}</CardTitle>
                            </div>
                        </CardHeader>
                        <CardContent>
                            <CardDescription class="mb-3">{guide.description}</CardDescription>
                            <div class="flex items-center text-sm text-primary">
                                Read guide
                                <ArrowRight class="ml-1 h-4 w-4" />
                            </div>
                        </CardContent>
                    </Card>
                </Link>
            {/each}
        </div>
    </GuidesLayout>
</AppLayout>